import MaxCostChanges from './MaxCostChanges.styled';

export default MaxCostChanges;
